/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTeamMemberAvailability} from '../api'

 export const useQueryGetTeamMemberAvailability = createReactQueryHook('getTeamMemberAvailability', getTeamMemberAvailability)
